"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UserGridOptions {
    constructor() {
        this.division = true;
        this.carrier = true;
        this.account = true;
        this.payer = true;
        this.invoiceNumber = true;
        this.PDF = true;
        this.originalAmount = true;
        this.amountDue = true;
        this.adjustedAmount = true;
        this.invoiceDate = true;
        this.invoiceDueDate = true;
        this.glCoding = true;
        this.remittanceNumber = true;
        this.disbursementNumber = true;
        this.disbursementAmount = true;
        this.receivedAmount = true;
        this.receivedDate = true;
        this.audited = true;
        this.dispute = true;
        this.approve = true;
        this.allocate = true;
        this.received = true;
        this.disburse = true;
        this.status = true;
        this.paidAmount = true;
    }
}
exports.UserGridOptions = UserGridOptions;
//# sourceMappingURL=UserGridOptions.js.map